// extracted by mini-css-extract-plugin
export default {"copyButton":"ValidationMapping_copyButton__zNDAJ","tableRowFieldRequired":"ValidationMapping_tableRowFieldRequired__jiTgN"};